import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { BaseApiService, SalesforceApiService } from '../api';
import { MappingFieldsRequestParamDto, SettingsResponse } from '../../dto';
import { CrmServiceInterface } from './interface';
import { ExportTypeEnum } from '../../enums';
import { AbstractCrmService } from './abstract-crm-service';

@Injectable({
  providedIn: 'root',
})
export class SalesforceService extends AbstractCrmService implements CrmServiceInterface<any> {

  isFromInboxIntel = false;
  isFromInboxIntelCompany = false;
  isReconnect = false;
  isReconnectCompany = false;

  constructor(
    readonly salesforceApiService: SalesforceApiService,
    readonly baseApiService: BaseApiService,
  ) {
    super(baseApiService);
  }

  getExportType(): ExportTypeEnum {
    return ExportTypeEnum.SALESFORCE;
  }

  authenticate(code: string, param?: any): Observable<any> {
    return this.salesforceApiService.authenticate(code);
  }

  logout(): Observable<any> {
    return this.salesforceApiService.logout();
  }

  getSettings(): Observable<SettingsResponse> {
    return this.salesforceApiService.getSettings();
  }

  getMappingFields(params: MappingFieldsRequestParamDto = {}): Observable<any> {
    return this.salesforceApiService.getMappingFields(params);
  }

  setSettings(settings: any): Observable<any> {
    return this.salesforceApiService.saveSettings(settings);
  }

  getLeadOwners(): Observable<any> {
    return this.salesforceApiService.getLeadOwners();
  }

  getCampaigns(): Observable<any> {
    return this.salesforceApiService.getCampaigns();
  }
}
